function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5001 5.60833C17.4834 5.60833 17.4584 5.60833 17.4334 5.60833C13.0251 5.16667 8.62505 5 4.26672 5.44167L2.56672 5.60833C2.21672 5.64167 1.90839 5.39167 1.87505 5.04167C1.84172 4.69167 2.09172 4.39167 2.43339 4.35833L4.13338 4.19167C8.56672 3.74167 13.0584 3.91667 17.5584 4.35833C17.9001 4.39167 18.1501 4.7 18.1167 5.04167C18.0917 5.36667 17.8167 5.60833 17.5001 5.60833Z",
  fill: "#F72B2B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.08314 4.76666C7.0498 4.76666 7.01647 4.76666 6.9748 4.75833C6.64147 4.7 6.40814 4.375 6.46647 4.04166L6.6498 2.95C6.78314 2.15 6.96647 1.04166 8.90814 1.04166H11.0915C13.0415 1.04166 13.2248 2.19166 13.3498 2.95833L13.5331 4.04166C13.5915 4.38333 13.3581 4.70833 13.0248 4.75833C12.6831 4.81666 12.3581 4.58333 12.3081 4.25L12.1248 3.16666C12.0081 2.44166 11.9831 2.3 11.0998 2.3H8.91647C8.03314 2.3 8.01647 2.41666 7.89147 3.15833L7.6998 4.24166C7.6498 4.55 7.38314 4.76666 7.08314 4.76666Z",
  fill: "#F72B2B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.675 18.9583H7.325C4.41666 18.9583 4.3 17.35 4.20833 16.05L3.66666 7.65832C3.64166 7.31665 3.90833 7.01665 4.25 6.99165C4.6 6.97499 4.89166 7.23332 4.91666 7.57499L5.45833 15.9667C5.55 17.2333 5.58333 17.7083 7.325 17.7083H12.675C14.425 17.7083 14.4583 17.2333 14.5417 15.9667L15.0833 7.57499C15.1083 7.23332 15.4083 6.97499 15.75 6.99165C16.0917 7.01665 16.3583 7.30832 16.3333 7.65832L15.7917 16.05C15.7 17.35 15.5833 18.9583 12.675 18.9583Z",
  fill: "#F72B2B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3834 14.375H8.6084C8.26673 14.375 7.9834 14.0917 7.9834 13.75C7.9834 13.4083 8.26673 13.125 8.6084 13.125H11.3834C11.7251 13.125 12.0084 13.4083 12.0084 13.75C12.0084 14.0917 11.7251 14.375 11.3834 14.375Z",
  fill: "#F72B2B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0832 11.0417H7.9165C7.57484 11.0417 7.2915 10.7583 7.2915 10.4167C7.2915 10.075 7.57484 9.79166 7.9165 9.79166H12.0832C12.4248 9.79166 12.7082 10.075 12.7082 10.4167C12.7082 10.7583 12.4248 11.0417 12.0832 11.0417Z",
  fill: "#F72B2B"
});

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.91929711.svg";
export { ForwardRef as ReactComponent };